import formsBackendClient from '@/tsClient/servers/noodleQuestionnaires';

const publishDynamicPdfTemplate = async (id: string): Promise<void> => {
  const response = await formsBackendClient.post(`/dynamic-pdf-templates/${id}/publish`);
  return response.data;
};

export default publishDynamicPdfTemplate;
